export const CHECK_DOCUMENT = 'v2/registration/document/check';
export const REGISTER = 'v2/registration/user';